import { useEffect, useState } from 'react';
import InitFilters from './constants/InitFiltering';

const useCustomHook = (currencyText) => {
  const [loading, setLoading] = useState(true);
  const [filterParams, setFilterParams] = useState(null); // useful for export
  const [activeDetailID, setActiveDetailID] = useState(null);
  const [filters, setFilters] = useState(() => InitFilters(currencyText));
  const [isTransferOpen, setIsTransferOpen] = useState(false);
  const [targetTransferDelegation, setTargetTransferDelegation] = useState(null);
  const [emptyLabel, setEmptyLabel] = useState('داده‌ای یافت نشد!');
  const [size, setSize] = useState(50);
  const [page, setPage] = useState(0);
  const [showDialog, setShowDialog] = useState(false);
  const [dataDialog, setDataDialog] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [paramsData, setParamsData] = useState(null);

  useEffect(() => {
    if (!currencyText) return;

    setFilters((currentFilters) =>
      currentFilters.map((filter) =>
        filter.keyName === 'amountRange' || filter.keyName === 'usedRange'
          ? { ...filter, unit: currencyText }
          : filter,
      ),
    );
  }, [currencyText]);


  return {
    showDialog, setShowDialog,
    dataDialog, setDataDialog,
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    size,
    setSize,
    activeDetailID,
    setActiveDetailID,
    filters,
    setFilters,
    isTransferOpen,
    setIsTransferOpen,
    targetTransferDelegation,
    setTargetTransferDelegation,
    emptyLabel,
    setEmptyLabel,
    page, setPage,
    dateRange, setDateRange,
    paramsData, setParamsData
  };
};

export default useCustomHook;
